var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app"},[_c('PageTitle',{attrs:{"title":_vm.getPageTitle}}),_c('Dashboard'),_c('UIMessage',[_c('p',[_vm._v("This application uses the browser's Local Storage to store data.")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }